import {buildAssistantEntityContext, type AssistantEntityContext} from '@dms/ai-assistant';
import type {BusinessCaseResponseBody} from '@dms/api/finance';

import {getPurchaseVehicleIdFromBusinessCase} from './getPurchaseVehicleIdFromBusinessCase';
import {getSaleVehicleIdFromBusinessCase} from './getSaleVehicleIdFromBusinessCase';

interface BusinessCaseAssistantEntityLabels {
  customer?: string | null;
  vehicle?: string | null;
}

/**
 * Records loaded by a mounted business-case page. Returns `undefined` until the loaded case belongs
 * to the route id, so a record switch cannot leak the previous case or its related records.
 */
export const getBusinessCaseAssistantEntities = (
  businessCaseId: string,
  businessCase: BusinessCaseResponseBody | undefined,
  labels: BusinessCaseAssistantEntityLabels = {}
): AssistantEntityContext | undefined => {
  if (businessCase?.id !== businessCaseId) {
    return undefined;
  }

  const vehicleId =
    getSaleVehicleIdFromBusinessCase(businessCase) ??
    getPurchaseVehicleIdFromBusinessCase(businessCase);

  return buildAssistantEntityContext({
    businessCase: {id: businessCase.id, label: businessCase.code},
    vehicle: typeof vehicleId === 'string' ? {id: vehicleId, label: labels.vehicle} : vehicleId,
    customer: {id: businessCase.customerId, label: labels.customer},
    interest: businessCase.interestId,
  });
};
